import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentParagraphGroupComponent } from './component-paragraph-group.component';
import { PipeModule } from 'src/app/pipe/pipe.module';

@NgModule({
  declarations: [
    ComponentParagraphGroupComponent
  ],
  imports: [
    CommonModule,
    PipeModule
  ],
  exports: [
    ComponentParagraphGroupComponent
  ]
})
export class ComponentParagraphGroupModule { }
